import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng-fe/errorBoundary';
import ModuleHead from '../../components/moduleHead';
import ModuleFeed from '../../components/moduleFeed';

class Invest extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    /**
     * 渲染组件
     */
    render() {
        const { investHead, investBref, investData } = this.props.content;

        return (
            <div className={styles.news}>
                <Chip id="260662" type="struct" title="投资观察标题" groupName="投资观察" content={investHead}>
                    <ModuleHead />
                </Chip>
                <ModuleFeed bref={investBref} lists={investData} title="投资观察" brefId="260663" />
            </div>
        );
    }
}

export default errorBoundary(Invest);
